import React, { useMemo, useState, useEffect } from "react";


import { LS_DIALER_SUBACCOUNT_ACCESS_LIST_PER_PAGE } from "const/localStorageKeys";
import { useWindowWidth } from "hooks";
import { getSafeValue, resolvePerPage } from "utils";
import { FilterSectionFlexboxGrid, StyledItemFitWidth, StyledItemAutoMargin } from "components/base/FitContainers";
import { ButtonPrimary } from "components/base/BaseButton";
import PageHeader from "components/base/PageHeader";
import Page from "components/base/Page";
import m from "definedMessages";
import AccessListTable from "./AccessListTable";
import AccessListFilter from "./AccessListFilter";


import { useIntl } from "react-intl";
import { Schema } from "rsuite";

const defaultFilterValue = {
    filter_cli: "",
    filter_phone: ""
};

const MIN_LENGTH = 3;
const MAX_LENGTH = 40;

const { StringType } = Schema.Types;


const AccessList = ({
    data,
    page,
    count,
    perPage,
    loading,
    accountJoinList,

    getList,
    exportAccessList
}) => {

    const windowWidth = useWindowWidth();
    const isMobile = windowWidth < 767;
    const issueWidth = windowWidth < 960;

    const { formatMessage } = useIntl();

    const filtersModel = Schema.Model({
        filter_cli: StringType()
            .minLength(MIN_LENGTH, formatMessage(m.minLength, { count: MIN_LENGTH }))
            .maxLength(MAX_LENGTH, formatMessage(m.maxLength, { count: MAX_LENGTH })),
        filter_phone: StringType()
            .minLength(MIN_LENGTH, formatMessage(m.minLength, { count: MIN_LENGTH }))
            .maxLength(MAX_LENGTH, formatMessage(m.maxLength, { count: MAX_LENGTH }))
    });

    const accountData = useMemo(() => {
        return accountJoinList.find((account) => {
            return account.service === "voice";
        })
    }, [accountJoinList]);

    const defaultSort = { column: "access_origin", type: "asc" };

    const [filterState, setFilterState] = useState(defaultFilterValue);
    const [sort, setSort] = useState(defaultSort);

    const resolvedPerPage = useMemo(() => resolvePerPage(
        LS_DIALER_SUBACCOUNT_ACCESS_LIST_PER_PAGE,
        perPage,
    ), [perPage]);

    useEffect(() => {
        update(1, resolvedPerPage, defaultSort);
    }, [accountData]);

    useEffect(() => {
        getItems(1, perPage, sort);
    }, [filterState]);

    const update = (_page, _perPage, _sort) => {
        if (accountData && accountData.id) {
            getList(accountData.id, filterState, _page, _perPage, _sort);
        }
    };

    const getItems = (_page = 1, _perPage = resolvedPerPage, _sort = defaultSort) => {
        const checker = filtersModel.check(filterState);
        const formHasError = Object.keys(checker).some(key => checker[key].hasError);

        if (formHasError)
            return;

        update(_page, _perPage, _sort);
    };


    return <Page>
        <PageHeader title={formatMessage(m.accessList)} showService={false}></PageHeader>
        <FilterSectionFlexboxGrid>
            <StyledItemFitWidth isMobile={isMobile}>
                <AccessListFilter
                    model={filtersModel}
                    filter={filterState}
                    disabled={loading}
                    issueWidth={issueWidth}

                    onChangeFilter={setFilterState}
                    formatMessage={formatMessage}
                />
            </StyledItemFitWidth>
            <StyledItemAutoMargin isMobile={isMobile}>
                <ButtonPrimary
                    className="export-button"
                    buttonStyle="default"
                    disabled={loading}
                    onClick={() => {
                        if (accountData && accountData.id) {
                            exportAccessList(accountData.id, filterState);
                        }
                    }}
                >
                    {formatMessage(m.exportToCsv)}
                </ButtonPrimary>
            </StyledItemAutoMargin>
        </FilterSectionFlexboxGrid>
        <AccessListTable
            data={data}
            sort={sort}
            page={page}
            count={count}
            perPage={perPage}
            loading={loading}
            isMobile={isMobile}

            setSort={setSort}
            getItems={getItems}

            formatMessage={formatMessage}
        />
    </Page>
};

export default AccessList;